import type { AutomationEffectAnomaly } from '@/types/admin.types';
import { AlertTriangle, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface EffectAnomaliesAlertProps {
  count: number;
  anomalies?: AutomationEffectAnomaly[];
}

export function EffectAnomaliesAlert({ count, anomalies = [] }: EffectAnomaliesAlertProps) {
  if (count <= 0) return null;

  return (
    <section
      role="alert"
      aria-label="Anomalies de preuves d’effets"
      className="rounded-2xl border border-danger-300 bg-danger-50 p-4 dark:border-danger-500/30 dark:bg-danger-500/10"
    >
      <div className="flex items-start gap-3">
        <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-danger-600" />
        <div className="min-w-0 flex-1">
          <p className="font-semibold text-danger-800 dark:text-danger-300">
            {count} exécution{count > 1 ? 's' : ''} avec un effet non prouvé
          </p>
          <p className="mt-1 text-sm text-danger-700 dark:text-danger-300">
            La configuration, le résultat OpenPaye ou le journal d’envoi ne concordent pas. Vérifiez
            ces dossiers avant qu’un écart soit constaté côté client.
          </p>
          {anomalies.length > 0 && (
            <ul className="mt-3 grid gap-2 sm:grid-cols-2">
              {anomalies.slice(0, 6).map((anomaly) => (
                <li key={anomaly.executionUuid}>
                  <Link
                    to={`/automations/executions/${anomaly.executionUuid}`}
                    className="flex items-center justify-between gap-2 rounded-lg border border-danger-200 bg-white/70 px-3 py-2 text-sm font-medium text-danger-800 transition-colors hover:bg-white dark:border-danger-500/20 dark:bg-neutral-900/40 dark:text-danger-300"
                  >
                    <span className="truncate">
                      {anomaly.folderName} — {anomaly.templateId}
                    </span>
                    <ArrowRight className="h-4 w-4 shrink-0" />
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </section>
  );
}
